// extracted by mini-css-extract-plugin
export var chip = "_f8-0";
export var filterDropdown = "_f8-5";
export var filterItem = "_f8-6";
export var icon = "_f8-1";
export var removeButton = "_f8-3";
export var removeIcon = "_f8-4";
export var separator = "_f8-2";